/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CitizenshipStatus {
  US_CITIZEN = 'US_CITIZEN',
  RESIDENT_ALIEN = 'RESIDENT_ALIEN',
  OTHER = 'OTHER',
}
